import React from "react";
import {
    FormGroup,
    Label,
    Input,
    Button,
    FormFeedback,
    Row,
    Col
} from "reactstrap";
import { ACCOUNT_TYPES } from "../../../../constants/paymentConstants";
import PhoneInput from "../../../../components/Forms/PhoneInput"

export default function AdminBillingOptions({
                                                formik,
                                                accounts,
                                                usingExisting,
                                                usingNewInvoice,
                                                handleBillingOptionChange,
                                                handleAccountChange,
                                                handleAccountTypeChange,
                                                handleResetAccount
                                            }) {
    return (
        <>
            <FormGroup>
                <Label>Cari/Fatura Seçenekleri</Label>
                <Input
                    type="select"
                    name="billingOption"
                    onChange={handleBillingOptionChange}
                    value={formik.values.billingOption}
                    invalid={
                        formik.touched.billingOption && !!formik.errors.billingOption
                    }
                >
                    <option value="">-- Seçiniz --</option>
                    <option value="existing_account">Mevcut cari/bayi kullan</option>
                    <option value="new_invoice">Yeni fatura bilgileri gir</option>
                    <option value="no_invoice">
                        Fatura veya cari/bayi seçmeden devam et
                    </option>
                </Input>
                {formik.touched.billingOption && (
                    <FormFeedback>{formik.errors.billingOption}</FormFeedback>
                )}
            </FormGroup>

            {usingExisting && (
                <FormGroup>
                    <Label>Cari/Bayi Seç</Label>
                    <div className="d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center gap-2">
                        <Input
                            type="select"
                            name="accountId"
                            onChange={handleAccountChange}
                            value={formik.values.accountId}
                            invalid={formik.touched.accountId && !!formik.errors.accountId}
                            className="me-2"
                        >
                            <option value="">-- Cari/Bayi seçiniz --</option>
                            {accounts.map((acc) => (
                                <option key={acc.id} value={acc.id}>
                                    {acc.accountName}
                                </option>
                            ))}
                        </Input>
                        {formik.values.accountId && (
                            <Button
                                color="outline-secondary"
                                size="sm"
                                onClick={handleResetAccount}
                                title="Cari/Bayi Seçimini Sıfırla"
                            >
                                <i className="bx bx-refresh me-1"></i>
                                Temizle
                            </Button>
                        )}
                    </div>
                    {formik.touched.accountId && (
                        <FormFeedback>{formik.errors.accountId}</FormFeedback>
                    )}
                </FormGroup>
            )}

            {usingNewInvoice && (
                <fieldset className="mb-3">
                    <legend style={{ fontSize: "1rem", fontWeight: "600" }}>
                        Fatura Bilgileri
                    </legend>

                    <FormGroup>
                        <Label>Cari/Bayi Tipi *</Label>
                        <Input
                            type="select"
                            name="invoiceAccountType"
                            onChange={handleAccountTypeChange}
                            value={formik.values.invoiceAccountType}
                            invalid={
                                formik.touched.invoiceAccountType &&
                                !!formik.errors.invoiceAccountType
                            }
                        >
                            <option value="">-- Cari/Bayi tipi seçiniz --</option>
                            {ACCOUNT_TYPES.map((type) => (
                                <option key={type.value} value={type.value}>
                                    {type.label}
                                </option>
                            ))}
                        </Input>
                        {formik.touched.invoiceAccountType && (
                            <FormFeedback>{formik.errors.invoiceAccountType}</FormFeedback>
                        )}
                    </FormGroup>

                    <FormGroup>
                        <Label>Şirket Adı *</Label>
                        <Input
                            name="invoiceCompanyName"
                            onChange={formik.handleChange}
                            value={formik.values.invoiceCompanyName}
                            placeholder="Fatura şirket adı"
                            invalid={
                                formik.touched.invoiceCompanyName &&
                                !!formik.errors.invoiceCompanyName
                            }
                        />
                        {formik.touched.invoiceCompanyName && (
                            <FormFeedback>{formik.errors.invoiceCompanyName}</FormFeedback>
                        )}
                    </FormGroup>

                    {formik.values.invoiceAccountType === "SOLE_PROPRIETORSHIP" ? (
                        <FormGroup>
                            <Label>T.C. Kimlik No *</Label>
                            <Input
                                name="invoiceTcNumber"
                                onChange={formik.handleChange}
                                value={formik.values.invoiceTcNumber}
                                placeholder="T.C. kimlik numarası (11 haneli)"
                                maxLength={11}
                                invalid={
                                    formik.touched.invoiceTcNumber &&
                                    !!formik.errors.invoiceTcNumber
                                }
                            />
                            {formik.touched.invoiceTcNumber && (
                                <FormFeedback>{formik.errors.invoiceTcNumber}</FormFeedback>
                            )}
                        </FormGroup>
                    ) : (
                        formik.values.invoiceAccountType &&
                        formik.values.invoiceAccountType !== "SOLE_PROPRIETORSHIP" && (
                            <FormGroup>
                                <Label>Vergi No *</Label>
                                <Input
                                    name="invoiceTaxNumber"
                                    onChange={formik.handleChange}
                                    value={formik.values.invoiceTaxNumber}
                                    placeholder="Vergi numarası (10 haneli)"
                                    maxLength={10}
                                    invalid={
                                        formik.touched.invoiceTaxNumber &&
                                        !!formik.errors.invoiceTaxNumber
                                    }
                                />
                                {formik.touched.invoiceTaxNumber && (
                                    <FormFeedback>{formik.errors.invoiceTaxNumber}</FormFeedback>
                                )}
                            </FormGroup>
                        )
                    )}

                    <FormGroup>
                        <Label>Vergi Dairesi *</Label>
                        <Input
                            name="invoiceTaxOffice"
                            onChange={formik.handleChange}
                            value={formik.values.invoiceTaxOffice}
                            placeholder="Vergi dairesi"
                            invalid={
                                formik.touched.invoiceTaxOffice &&
                                !!formik.errors.invoiceTaxOffice
                            }
                        />
                        {formik.touched.invoiceTaxOffice && (
                            <FormFeedback>{formik.errors.invoiceTaxOffice}</FormFeedback>
                        )}
                    </FormGroup>

                    <FormGroup>
                        <Label>Adres *</Label>
                        <Input
                            type="textarea"
                            name="invoiceAddress"
                            onChange={formik.handleChange}
                            value={formik.values.invoiceAddress}
                            placeholder="Fatura adresi"
                            rows={2}
                            invalid={
                                formik.touched.invoiceAddress &&
                                !!formik.errors.invoiceAddress
                            }
                        />
                        {formik.touched.invoiceAddress && (
                            <FormFeedback>{formik.errors.invoiceAddress}</FormFeedback>
                        )}
                    </FormGroup>

                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Label>E-posta</Label>
                                <Input
                                    type="email"
                                    name="invoiceEmail"
                                    onChange={formik.handleChange}
                                    value={formik.values.invoiceEmail}
                                    placeholder="email@example.com"
                                    invalid={
                                        formik.touched.invoiceEmail &&
                                        !!formik.errors.invoiceEmail
                                    }
                                />
                                {formik.touched.invoiceEmail && (
                                    <FormFeedback>{formik.errors.invoiceEmail}</FormFeedback>
                                )}
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <PhoneInput
                                label="Telefon"
                                name="invoicePhone"
                                value={formik.values.invoicePhone}
                                onChange={formik.handleChange}
                                invalid={formik.touched.invoicePhone && !!formik.errors.invoicePhone} // ✨
                                placeholder="+90532xxxxxxx"
                                maxLength={15}
                            />
                            {formik.touched.invoicePhone && (
                                <FormFeedback className="d-block">
                                    {formik.errors.invoicePhone}
                                </FormFeedback>
                            )}
                        </Col>
                    </Row>
                </fieldset>
            )}
        </>
    );
}